import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import IndependentResearch from "@/pages/IndependentResearch";
import ForResearchTeams from "@/pages/ForResearchTeams";
import ForSMEs from "@/pages/ForSMEs";
import About from "@/pages/About";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Contact from "@/pages/Contact";
import PaymentReturn from "@/pages/PaymentReturn";
import Simulator from "@/pages/Simulator";
import Book from "@/pages/Book";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/independent-research" element={<IndependentResearch />} />
            <Route path="/for-research-teams" element={<ForResearchTeams />} />
            <Route path="/for-smes" element={<ForSMEs />} />
            <Route path="/about" element={<About />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:slug" element={<ArticleDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/simulator" element={<Simulator />} />
            <Route path="/book" element={<Book />} />
            <Route path="/payment-return" element={<PaymentReturn />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
